import { css } from '@emotion/react';
import { Box, Text } from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';

import { useMockInterviewJobNames } from '../hooks/useMockInterviewJobNames';
import { SectionHead } from './SectionHead';
import { LANDING_COLOR, LANDING_FONT, LANDING_MOBILE_MQ, LANDING_SPACE } from './constants';

/** privacy 답변은 임시 문구 — 법무 확정본으로 교체 필요 */
const FAQ_ITEMS = [
  'price',
  'resume_required',
  'continue',
  'environment',
  'report',
  'privacy',
] as const;

export const Faq = () => {
  const { t } = useTranslation();
  const jobNames = useMockInterviewJobNames();

  return (
    <Box
      component="section"
      id="faq"
      css={styles.section}
      data-reveal
      aria-labelledby="ai-faq-title"
    >
      <Box css={styles.inner}>
        <SectionHead id="ai-faq-title" titleKey="ai_interviews.landing.faq.title" />

        <Box css={styles.list}>
          {FAQ_ITEMS.map((item, index) => (
            <Box
              key={item}
              css={[styles.row, index === FAQ_ITEMS.length - 1 ? styles.rowLast : null]}
            >
              <Text component="h3" css={styles.question}>
                {t(`ai_interviews.landing.faq.${item}.q`)}
              </Text>
              <Text css={styles.answer}>
                {t(`ai_interviews.landing.faq.${item}.a`)}
                {item === 'environment' &&
                  jobNames.length > 0 &&
                  ` ${t('ai_interviews.landing.faq.environment.jobs', { jobs: jobNames.join(', ') })}`}
              </Text>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

const styles = {
  section: css({
    background: LANDING_COLOR.surface,
    padding: `${LANDING_SPACE.sectionY} ${LANDING_SPACE.pageX} ${LANDING_SPACE.sectionBottomLg}`,
  }),
  inner: css({
    maxWidth: 1200,
    margin: '0 auto',
  }),
  list: css({
    marginTop: LANDING_SPACE.blockTop,
  }),
  row: css({
    display: 'grid',
    gridTemplateColumns: 'minmax(140px, 300px) 1fr',
    gap: LANDING_SPACE.rowGap,
    padding: `${LANDING_SPACE.rowY} 0`,
    borderTop: `1px solid ${LANDING_COLOR.line}`,
    [LANDING_MOBILE_MQ]: {
      gridTemplateColumns: '1fr',
    },
  }),
  rowLast: css({
    borderBottom: `1px solid ${LANDING_COLOR.line}`,
  }),
  question: css({
    margin: 0,
    fontSize: LANDING_FONT.body,
    fontWeight: 600,
    color: LANDING_COLOR.ink,
    lineHeight: 1.5,
    wordBreak: 'keep-all',
  }),
  answer: css({
    fontSize: LANDING_FONT.body,
    lineHeight: 1.75,
    color: LANDING_COLOR.bodyMuted,
    textWrap: 'pretty',
    wordBreak: 'keep-all',
  }),
};
